import { navigate } from 'gatsby';
import React from 'react';

import { AuthContext } from './AuthWrapper';

const propTypes = {};

function AuthenticatedRoute({ component: Component, render, ...props }) {
  const { pathname } = props.location;
  return (
    <AuthContext.Consumer>
      {({ tokenResponse }) => {
        if (!tokenResponse && pathname !== '/login') {
          navigate('/login', { replace: true });
          return null;
        }
        return Component ? <Component {...props} /> : render(props);
      }}
    </AuthContext.Consumer>
  );
}

AuthenticatedRoute.propTypes = propTypes;

export default AuthenticatedRoute;
